<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>Filtrowanie</h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Imię</label>
          <b-form-input
            :value="firstNameFilter"
            placeholder="Imię"
            @input="val => $emit('update:firstNameFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Nazwisko</label>
          <b-form-input
            :value="lastNameFilter"
            placeholder="Nazwisko"
            @input="val => $emit('update:lastNameFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Termin ważności od</label>
          <clearable-form-datepicker
            :value="validUntilFrom"
            locale="pl"
            hide-header
            label-help=""
            placeholder="Data od"
            @input="val => $emit('update:validUntilFrom', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Termin ważności do</label>
          <clearable-form-datepicker
            :value="validUntilTo"
            locale="pl"
            hide-header
            label-help=""
            placeholder="Data do"
            @input="val => $emit('update:validUntilTo', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Poziom dostępu</label>
          <v-select
            :value="roleFilter"
            :options="roleOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Wybierz"
            :clearable="true"
            @input="val => $emit('update:roleFilter', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Data certyfikacji od</label>
          <clearable-form-datepicker
            :value="certificationDateFrom"
            locale="pl"
            hide-header
            label-help=""
            placeholder="Data od"
            @input="val => $emit('update:certificationDateFrom', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Data certyfikacji do</label>
          <clearable-form-datepicker
            :value="certificationDateTo"
            locale="pl"
            hide-header
            label-help=""
            placeholder="Data do"
            @input="val => $emit('update:certificationDateTo', val)"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Zaliczony</label>
          <v-select
            :value="passedFilter"
            :options="passedOptions"
            class="w-100"
            :reduce="val => val.value"
            placeholder="Wybierz"
            :clearable="true"
            @input="val => $emit('update:passedFilter', val)"
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ClearableFormDatepicker from '@core/components/clearable-form-datepicker/ClearableFormDatepicker.vue'

const roleOptions = [
  { value: 'ROLE_MANAGER', label: 'Manager' },
  { value: 'ROLE_EMPLOYEE', label: 'Pracownik' },
]

const passedOptions = [
  { value: 'passed', label: 'Tak' },
  { value: 'failed', label: 'Nie' },
  { value: 'none', label: 'Brak' },
]

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    vSelect,
    ClearableFormDatepicker,
  },
  props: {
    firstNameFilter: {
      type: String,
      default: '',
    },
    lastNameFilter: {
      type: String,
      default: '',
    },
    validUntilFrom: {
      type: [String, null],
      default: null,
    },
    validUntilTo: {
      type: [String, null],
      default: null,
    },
    roleFilter: {
      type: [String, null],
      default: null,
    },
    certificationDateFrom: {
      type: [String, null],
      default: null,
    },
    certificationDateTo: {
      type: [String, null],
      default: null,
    },
    passedFilter: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      roleOptions,
      passedOptions,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
